// extracted by mini-css-extract-plugin
export default {"assetDetails":"AssetDetails_assetDetails__cgQg2"};